<template>
  <div class="d-flex flex-column" v-if="searchOnButtonPress">
    <el-button class="mb-1" type="primary" @click="onSearchButtonPress">
      {{ $i18n.t('apply_filters') }}
    </el-button>
    <el-button plain @click="onDiscardButtonPress">{{ $i18n.t('discard_filters') }}</el-button>
  </div>
</template>

<script>
import EventBus from '../../../utils/event-bus'
import { get } from 'lodash'

export default {
  name: 'SearchButton',
  computed: {
    id() {
      return this.$get('id')
    },
    panelId() {
      return this.$get('panelId')
    },
    searchOnButtonPress() {
      return get(this.$get('extendedOptions'), 'searchKeypress', false)
    },
  },
  methods: {
    onSearchButtonPress() {
      this.$emit('search-button-pressed')
      EventBus.$emit(`apply-filter-${this.id}`, { id: this.id, type: 'button' })
    },
    onDiscardButtonPress() {
      this.$emit('discard-button-pressed')
      EventBus.$emit(`reset-filter-${this.id}`, { id: this.id })
    },
  },
}
</script>
